<template functional>
  <g :transform="props.transform">
    <g v-for="item in props.letter" :key="item.d">
      <path :d="item.d" :class="item.class" :stroke-linecap="item.strokeLinecap" />
    </g>
  </g>
</template>

<script>
export default {
  name: "Paths",
  props: {
    letter: {
      type: Array,
      required: true,
    },
    transform: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.vert {
  transform-origin: center bottom;
}
.hori {
  transform-origin: 0% 50%;
}
.diag-left {
  transform-origin: 100% 100%;
}
.diag-right {
  transform-origin: 100% 0%;
}

.line {
  opacity: 0;
}
</style>
